var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsBank = function SvgUsBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "us-bank_svg__Calque_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".us-bank_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "us-bank_svg__st0",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "us-bank_svg__Calque_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "us-bank_svg___x31__2_",
    d: "M4 16.7v6.4L9.4 25l5.4-1.9v-6.4H4z",
    style: {
      fill: "#dc142e"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "us-bank_svg___x31__1_",
    d: "M9.4 22.9H7.7v-.5c-.2.4-.7.6-1.4.6-.8 0-1.5-.4-1.5-1.5v-3.1h1.7v2.4c0 .5.1.9.5.9.3 0 .7-.2.7-.9v-2.4h1.7v4.5zm3.2-3.2c0-.2-.1-.3-.2-.4-.1-.1-.3-.2-.4-.2-.3 0-.5.1-.5.4 0 .1.1.2.2.3.3.1.9.2 1.5.4.5.2 1.1.5 1.1 1.2 0 1.2-1.2 1.6-2.3 1.6s-2.2-.4-2.2-1.6h1.8c0 .2.1.3.2.4.1.1.3.1.4.1s.5-.1.5-.4-.2-.4-1-.4c-1.3-.2-1.9-.6-1.9-1.4 0-1.2 1.2-1.4 2.1-1.4 1 0 2.1.3 2.2 1.4h-1.5z",
    className: "us-bank_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "us-bank_svg___x31_",
    d: "M15.5 16.7h1.7v2.2c.3-.4.7-.6 1.2-.6 1.5 0 2 1.2 2 2.3 0 1.2-.6 2.4-1.9 2.4-.8 0-1.1-.4-1.3-.6v.4h-1.7v-6.1zm2.4 2.9c-.6 0-.7.5-.7 1.1 0 .5.1 1.2.7 1.2s.7-.5.7-1.2c.1-.6-.1-1.1-.7-1.1zm7.3 2.3c0 .4 0 .7.2 1h-1.8c0-.1-.1-.3-.1-.4-.4.4-.9.5-1.4.5-.9 0-1.6-.4-1.6-1.3 0-1.4 1.7-1.3 2.6-1.5.3 0 .4-.1.4-.4s-.3-.4-.5-.4c-.5 0-.6.3-.6.4h-1.6c.1-1.2 1.2-1.5 2.3-1.5 2.1 0 2.1.9 2.1 1.8v1.8zm-1.7-1c-.2.1-.4.2-.7.2-.4.1-.5.2-.5.4s.2.4.5.4c.4 0 .7-.3.7-.7v-.3zm2.3-2.5h1.7v.5c.4-.4.8-.7 1.4-.7.8 0 1.5.4 1.5 1.5v3.1h-1.7v-2.4c0-.5-.1-.9-.5-.9-.3 0-.7.2-.7.9v2.4h-1.7v-4.4zm5.2-1.7h1.7v3l1.1-1.3h2l-1.6 1.7 1.9 2.8h-2l-.9-1.6-.3.4V23H31v-6.3z",
    style: {
      fill: "#253779"
    }
  })));
};
export default SvgUsBank;